import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../../../utils/resources/fonts';
import { Colors } from '../../../../../../../utils/resources/colors';

export interface MultiselectCategoryCardCSSStyle extends UIComponentCSSStyle
{
    getImgCSSStyle(): object;
    getTitleCSSStyle(): object;
    getCheckboxCSSStyle(): object;
    getTintDivCSSStyle(): object;
}

export class MultiselectCategoryCardCSSStyleImpl extends UIComponentCSSStyleImpl implements MultiselectCategoryCardCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100px', 
            width: '71px', 
            objectFit: 'cover', 
            position: 'relative',
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '71px', 
            height: '71px',
            borderRadius: "5px"
        };
    }

    getTintDivCSSStyle(): object{
        return {
            position: "absolute",
            width: '71px', 
            height: '71px',
            display: "flex",
            borderRadius: "5px",
            cursor: "pointer",
            background: "linear-gradient(0deg, rgb(27, 25, 25, 0.73) 0%, rgb(218, 60, 128, 0.73) 100%)",
        };
    }

    getTitleCSSStyle(): object {
        return {
            // display: "flex",
            textAlign: "center",
            width: '100%', 
            height: '29px',
            fontWeight: "900",
            marginTop: "5px",
            letterSpacing: 0,
            overflow: "hidden",
            textOverflow: 'ellipsis',
            fontSize: this.getResources().getFont(Fonts.h6),
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getCheckboxCSSStyle(): object 
    {
        return {
            position: "absolute",
            top: "8px",
            alignItems: 'right', 
            right: "45px",
            left: "45px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcssstyle.tsx